'use client'

import React from 'react'

import { OB, FONT_MONO, Sparkle, StatusPill } from './kit'
import type { InvoiceStatus } from './kit'

/**
 * HeroProduct — the faux "Invoices" app card shown in the landing hero
 * (window chrome + dark KPI band + invoice rows + floating assistant toast).
 * Reused by the marketing landing (landing-v4 / MarketingLanding).
 */
export function HeroProduct() {
  const rows: { c: string; a: string; s: InvoiceStatus; col: string }[] = [
    { c: 'Helio Labs', a: '€9,200', s: 'paid', col: '#10b981' },
    { c: 'Acme Studio', a: '€14,500', s: 'sent', col: '#0ea5e9' },
    { c: 'Northwind Coffee', a: '€2,840', s: 'overdue', col: '#ef4444' },
  ]
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ background: '#fff', border: `1px solid ${OB.line2}`, borderRadius: 18, boxShadow: '0 24px 70px rgba(0,0,0,0.12)', overflow: 'hidden' }}>
        <div style={{ padding: '16px 20px', borderBottom: `1px solid ${OB.line}`, display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ display: 'flex', gap: 6 }}>
            {['#ef4444', '#f59e0b', '#10b981'].map((c, i) => <span key={i} style={{ width: 10, height: 10, borderRadius: '50%', background: c }}></span>)}
          </div>
          <span style={{ fontSize: 12.5, fontWeight: 600, color: OB.mute, marginLeft: 6 }}>Invoices</span>
          <div style={{ flex: 1 }}></div>
          <span style={{ fontSize: 11, color: OB.dim, fontFamily: FONT_MONO }}>April 2026</span>
        </div>
        {/* KPI */}
        <div style={{ padding: '18px 20px', background: OB.ink, color: '#fff' }}>
          <div style={{ fontSize: 10.5, color: 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: '0.09em', fontWeight: 600 }}>Outstanding</div>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginTop: 6 }}>
            <div style={{ fontSize: 30, fontWeight: 600, letterSpacing: '-0.03em' }}>€116,160</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11.5, color: '#6ee7b7', fontFamily: FONT_MONO }}>
              <Sparkle size={12} color={OB.lime}/> €42,120 predicted in 7d
            </div>
          </div>
        </div>
        {/* rows */}
        <div style={{ padding: '6px 8px' }}>
          {rows.map((r, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 12px', borderTop: i ? `1px solid ${OB.line}` : 'none' }}>
              <div style={{ width: 30, height: 30, borderRadius: 8, background: r.col, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{r.c.split(' ').map((w) => w[0]).slice(0, 2).join('')}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.c}</div>
                <div style={{ fontSize: 11, color: OB.dim, fontFamily: FONT_MONO }}>{r.a}</div>
              </div>
              <StatusPill status={r.s}/>
            </div>
          ))}
        </div>
      </div>
      {/* floating agent toast */}
      <div className="onb-float" style={{ position: 'absolute', bottom: -22, left: -26, background: '#fff', border: `1px solid ${OB.line2}`, borderRadius: 13, boxShadow: '0 16px 40px rgba(0,0,0,0.14)', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 11, maxWidth: 250 }}>
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'rgba(124,92,255,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Sparkle size={15} color={OB.purple}/>
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 12, fontWeight: 600 }}>Reminder sent to Northwind</div>
          <div style={{ fontSize: 11, color: OB.mute }}>Predicted to pay in 3 days</div>
        </div>
      </div>
    </div>
  )
}
